import React, { useState, useEffect } from 'react';
import { Table, Typography, Spin, ConfigProvider,Button,Space } from 'antd';
import Api from '../api/Api';
import formatarValor from '../formatarValor';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const { Title } = Typography;

const PedidosCozinha = () => {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);

  const primaryColor = 'rgb(249, 130, 68)';
  const secondaryColor = 'rgb(247, 72, 115)';
  const gradient = `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`;

  useEffect(() => {
    document.title = 'Pedidos da Cozinha';
    fetchPedidos();

    const interval = setInterval(() => {
      fetchPedidos();
    }, 10000); // atualiza a cada 10s

    return () => clearInterval(interval);
  }, []);



const handleEntregarProduto = async (pedidoId) => {
  try {
    setLoading(true);
    const dados = { id: pedidoId };
    const response = await Api.EntregarProduto(dados);

    if (response && response.success) {
      toast.success("Produto entregue com sucesso!");
      await fetchPedidos();
    } else {
      toast.error(response?.message);
    }
  } catch (error) {
   
    toast.error( error.message);
  } finally {
    setLoading(false);
  }
};





  const fetchPedidos = async () => {
    try {
      setLoading(true);
      const data = await Api.ListPedidoCozinha();
      setPedidos(data.map((p, idx) => ({ ...p, key: idx })));
    } catch (err) {
      console.error('Erro ao carregar pedidos da cozinha:', err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: <span style={{ fontSize: 22 }}>Mesa</span>,
      dataIndex: 'mesa',
      key: 'mesa',
      width: 70,
      render: (v) => <strong style={{ fontSize: 22 }}>{v}</strong>,
    },
    {
      title: <span style={{ fontSize: 22 }}>Produto</span>,
      dataIndex: 'produto',
      key: 'produto',
      width: 250,
      render: (v) => <span style={{ fontSize: 20 }}>{v}</span>,
    },
    {
      title: <span style={{ fontSize: 22 }}>Qtd</span>,
      dataIndex: 'quantidade',
      key: 'quantidade',
      align: 'center',
      width: 70,
      render: (v) => <strong style={{ fontSize: 24 }}>{v}</strong>,
    },
    {
      title: <span style={{ fontSize: 22 }}>Total</span>,
      dataIndex: 'total',
      key: 'total',
      align: 'right',
      width: 150,
      render: (v) => (
        <strong style={{ fontSize: 20 }}>
          {formatarValor(Number(v))}
        </strong>
      ),
    },
 {
 
  title: <span style={{ fontSize: 22 }}>Ações</span>,
  key: 'acoes',
  width: 100,
   align: 'center',
  render: (_, record) => (
    <Space size="small">
   <Button
      size="small"
      type="primary"
      style={{ background: '#52c41a', border: 'none' }}
      onClick={() => handleEntregarProduto(record.id)}
    >
      Entregar
    </Button>
 
    </Space>
  ),
     
 
},





  ];

  return (
    <ConfigProvider
      theme={{
        token: { colorPrimary: primaryColor, borderRadius: 8 },
      }}
    >
         <ToastContainer position="top-right" />
      <div
        style={{
          padding: 24,
          background: '#fff',
          minHeight: '100vh',
        }}
      >
        <div
          style={{
            marginBottom: 24,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Title
            level={2}
            style={{
              margin: 0,
              background: gradient,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: 36,
            }}
          >
            PEDIDOS PARA A COZINHA
          </Title>
        </div>

        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={pedidos}
            pagination={false}
            style={{
              borderRadius: 8,
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
            }}
            locale={{ emptyText: 'Nenhum pedido para preparar' }}
            rowClassName={() =>
              'cozinha-row'
            }
          />
        </Spin>

        {/* estilos extras para deixar as linhas grandes */}
        <style>
          {`
            .cozinha-row {
              height: 80px !important;
              font-size: 22px;
            }

            .ant-table-cell {
              padding-top: 20px !important;
              padding-bottom: 20px !important;
            }
          `}
        </style>
      </div>
    </ConfigProvider>
  );
};

export default PedidosCozinha;
